export default __webpack_public_path__ + "static/media/bg-valdano-pic-01@3x.a9f88744.jpg";